import '../assets/css/contact.css';
import { IoAlert } from "react-icons/io5";
import { FaHeart } from "react-icons/fa";
import { SiMinutemailer } from "react-icons/si";
import { FaArrowsSpin } from "react-icons/fa6";
import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import MobileMenu from "./MobileMenu";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const [errorMsg, setErrorMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [buttonDissable, setButtonDissable] = useState(false);


    const responceMessage = (type = null, msg = null) => {

        setErrorMsg("");
        setSuccessMsg("");

        if (type == 'error') {
            setErrorMsg(msg);
            setTimeout(() => { setErrorMsg(""); }, 5000);
        }
        else if (type == 'success') {
            setSuccessMsg(msg);
            setTimeout(() => { setSuccessMsg(""); }, 5000);
        }
    }

    const sendEmail = (e) => {
        e.preventDefault();
        setButtonDissable(true);
        emailjs
            .send(
                "service_g7s2vg9", // EmailJS Service ID
                "template_q9wol0g", // EmailJS Template ID
                formData,
                "aNb7wdXqmq2egkrBr" // EmailJS Public Key
            )
            .then(
                (response) => {
                    // console.log("SUCCESS!", response.status, response.text);
                    responceMessage('success', 'Email sent successfully');
                    setFormData({ name: "", email: "", subject: "", message: "" });
                    setButtonDissable(false);

                },
                (error) => {
                    // console.log("FAILED...", error);
                    responceMessage('error', 'Failed to send email. Please try again.');
                    setButtonDissable(false);

                }
            );
    };


    return (
        <div className="contact-container">
            {/* <MobileMenu /> */}
            <div className="contact-sub-container-body">
                <form onSubmit={sendEmail} >
                    <div className="contact-box">
                        <div className="box-contact">

                            <div className="box-contactBx">
                                <h2><span className='h2-icon'><SiMinutemailer /></span> Contact Me <span className='h2-icon heart-icon'><FaHeart /></span></h2>
                                <input type="text" placeholder="Your Name" name="name" value={formData.name} onChange={handleChange} required />
                                <input type="email" placeholder="Your Email" name="email" value={formData.email} onChange={handleChange} required />
                                <input type="text" placeholder="Subject" name="subject" value={formData.subject} onChange={handleChange} required />
                                <textarea className="message" placeholder="Message" name="message" value={formData.message} onChange={handleChange} required ></textarea>
                                <input type="submit" className={buttonDissable ? "" : "btn-enable"} value={buttonDissable ? "Sending..." : "Send"} disabled={buttonDissable ? "disabled" : ""} />
                                <span className="contact-msg"><span className="success-msg" >{successMsg}</span><span className="error-msg" >{errorMsg}</span> {buttonDissable ? <FaArrowsSpin className='spinner' /> : <IoAlert />}</span>
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Contact;